export default __webpack_public_path__ + "static/ShineMobileAppImage-ee65a642f0def10a99441d4bd715926624a719888df9da1dff1af6d022da1491.jpg";